<div class="desktop-buttons">
    @if(visibleButtons().includes(rightSidebarOptions.Statistics)) {
        <div class="statistics-icon-button icon-button" (click)="toggleVisibility(rightSidebarOptions.Statistics)">
            <ev-tooltip-simple class="tooltip statistics" text="Statistikk"></ev-tooltip-simple>
        </div>
    } @if(visibleButtons().includes(rightSidebarOptions.Filter)) {
        @if(this.mapStateService.mapModeSignal() === mapMode.Market2){
            <div class="filter-icon-button icon-button" [class.is-dirty]="isFilterDirty()" (click)="toggleVisibility(rightSidebarOptions.Filter)">
                <ev-tooltip-simple class="tooltip filter" text="Filter"></ev-tooltip-simple>
            </div>
        }
        @else {
            <div class="filter-icon-button icon-button" (click)="toggleVisibility(rightSidebarOptions.Filter)">
                <ev-tooltip-simple class="tooltip filter" text="Filter"></ev-tooltip-simple>
            </div>
        }
    } @if(visibleButtons().includes(rightSidebarOptions.Favorites)) {
        <div class="favorites-icon-button icon-button" (click)="toggleVisibility(rightSidebarOptions.Favorites)" [class.inEditMode]="mapStateService.estateListEditModeSignal()">
            <ev-tooltip-simple class="tooltip favorites" text="Lister"></ev-tooltip-simple>
        </div>
    }

    <freedraw-buttons [canShow]="canShowFreedrawButtons()"></freedraw-buttons>
</div>

<div class="mobile-buttons">
    @if(visibleButtons().includes(rightSidebarOptions.Statistics)) {
        <div class="statistics-icon-button icon-button" (click)="toggleVisibility(rightSidebarOptions.Statistics)"></div>
    }
    @if(visibleButtons().includes(rightSidebarOptions.Filter)) {
        @if(this.mapStateService.mapModeSignal() === mapMode.Market2){
            <div class="filter-icon-button icon-button" [ngClass]="{'is-dirty': isFilterDirty()}" (click)="toggleVisibility(rightSidebarOptions.Filter)"></div>
        }
        @else {
            <div class="filter-icon-button icon-button" (click)="toggleVisibility(rightSidebarOptions.Filter)"></div>
        }
    }
    @if(visibleButtons().includes(rightSidebarOptions.Favorites)) {
        <div class="favorites-icon-button icon-button" (click)="toggleVisibility(rightSidebarOptions.Favorites)" [class.inEditMode]="mapStateService.estateListEditModeSignal()"></div>
    }

    @if (canShowFreedrawButtons()) {
        <div class="freedraw-toggle-button icon-button" [class.active]="freedrawMobileExpanded" title="Områdevelger" (click)="freedrawMobileExpanded = !freedrawMobileExpanded">
            <div class="header"></div>
            <span class="dropdown-icon"></span>
        </div>
        @if (freedrawMobileExpanded) {
            <freedraw-buttons [canShow]="canShowFreedrawButtons()" [mobileMode]="true" (onRevert)="freedrawMobileExpanded = false"></freedraw-buttons>
        }
    }
</div>
